import { render, staticRenderFns } from "./ProductSalesPage.vue?vue&type=template&id=0975566c&scoped=true&"
import script from "./ProductSalesPage.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSalesPage.vue?vue&type=style&index=0&id=0975566c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975566c",
  null
  
)

export default component.exports